import 'tailwindcss/tailwind.css';
import { UserProvider } from '@auth0/nextjs-auth0';
import { hotjar } from 'react-hotjar';
import { useEffect, useState } from 'react';
import { axiosInst } from '../helpers';
import { useRouter } from 'next/router';

function MyApp({ Component, pageProps }) {
  const [notifications, setNotifications] = useState(null);
  const router = useRouter();
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_API_URL === 'https://slotit.herokuapp.com') {
      hotjar.initialize(2841865, 1);
    }
  }, []);

  useEffect(() => {
    async function fetchPending() {
      await fetchPendingSubscriptions();
    }

    if (router.pathname !== '/') {
      fetchPending();
    }
  }, [router]);

  async function fetchPendingSubscriptions() {
    try {
      const { data } = await axiosInst.get(`notifications`);
      setNotifications(data);
    } catch (error) {}
  }

  return (
    <UserProvider>
      <Component {...pageProps} notifications={notifications} />
    </UserProvider>
  );
}

export default MyApp;
